import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { SessionExpiredProvider } from "./context/SessionExpiredContext";
import "./styles/index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <SessionExpiredProvider>
        <App />
      </SessionExpiredProvider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
